export let API_GATEWAY_URL= "https://sox1uo9fs1.execute-api.us-east-1.amazonaws.com/test";
export let FRONTEND_AWS_URL="https://www.mathintercept.com";
export let NPM_CLERK_PUBLISHABLE_KEY = "pk_test_Y3V0ZS1ncmlmZm9uLTQxLmNsZXJrLmFjY291bnRzLmRldiQ";
